export default "__VITE_ASSET__Dn8J9PCH__"